import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import App from './components/App';
import NotFoundPage from './components/home/NotFoundPage';
import DashboardPage from './components/dashboard/DashboardPage';
import ImageDetailPage from './components/dashboard/ImageDetailPage';
import ImageCreationPage from './components/imaging/ImageCreationPage';
import ImageSourcePage from './components/imaging/ImageSourcePage';
import ImageSourceLocationPage from './components/imaging/ImageSourceLocationPage';
import ImageDestinationPage from './components/imaging/ImageDestinationPage';
import ImageCreationConfirmationPage from './components/imaging/ImageCreationConfirmationPage';
import CloneCreationPage from './components/cloning/CloneCreationPage';
import CloneSourcePage from './components/cloning/CloneSourcePage';
import CloneDestinationPage from './components/cloning/CloneDestinationPage';
import CloneCreationConfirmationPage from './components/cloning/CloneCreationConfirmationPage';
import SettingsPage from './components/settings/SettingsPage';
import AboutPage from './components/settings/AboutPage';
import SettingsPermissionsPage from './components/settings/PermissionsPage';
import SettingsPowerShellPage from './components/settings/PowerShellPage';
import GettingStartedPage from './components/home/GettingStartedPage';

export default <Route path="/" component={App}>
    <IndexRedirect to="/dashboard" />
    <Route path="dashboard" component={DashboardPage} />
    <Route path="dashboard/images/:imageId" component={ImageDetailPage} />
    <Route path="dashboard/getting-started" component={GettingStartedPage} />
    <Route path="images/create" component={ImageCreationPage}>
        <Route path="setup" component={ImageSourcePage} />
        <Route path="source" component={ImageSourceLocationPage} />
        <Route path="destination" component={ImageDestinationPage} />
        <Route path="review" component={ImageCreationConfirmationPage} />
    </Route>
    <Route path="clones/create" component={CloneCreationPage}>
        <Route path="source" component={CloneSourcePage} />
        <Route path="destination" component={CloneDestinationPage} />
        <Route path="review" component={CloneCreationConfirmationPage} />
    </Route>
    <Route path="settings" component={SettingsPage}>
        <IndexRedirect to="/settings/permissions" />
        <Route path="about" component={AboutPage} />
        <Route path="permissions" component={SettingsPermissionsPage} />
        <Route path="powershell" component={SettingsPowerShellPage} />
    </Route>
    
    <Route path="*" component={NotFoundPage} />
</Route>;



// WEBPACK FOOTER //
// ./src/routes.jsx